// src/services/epoReceivingApi.js
//
// Round 16 — receiving endpoints. Backs the EposReceive.js page that lets a
// shipper/IT-Admin mark line items as received, reopen them, or close the
// whole order at once. Mirrors Controllers/EPO/EpoReceivingController.cs.
import api from "../api";

/** POST .../receive/all → ReceiveAllResponse { LinesClosed, AllReceived } */
export async function receiveAll(epoNum) {
    const res = await api.post(`/epo/${epoNum}/receive/all`);
    return res.data;
}

/** POST .../receive/line/{n} → ReceiveLineResponse { AllReceived } */
export async function receiveLine(epoNum, lineNum) {
    const res = await api.post(`/epo/${epoNum}/receive/line/${lineNum}`);
    return res.data;
}

/** POST .../receive/line/{n}/reopen → 200 OK */
export async function reopenLine(epoNum, lineNum) {
    await api.post(`/epo/${epoNum}/receive/line/${lineNum}/reopen`);
}

/** PUT .../receive/line/{n}/qty (body: { Qty: decimal }) → 200 OK */
export async function updateLineQty(epoNum, lineNum, qty) {
    await api.put(`/epo/${epoNum}/receive/line/${lineNum}/qty`, { Qty: qty });
}

/**
 * Batch 1 / Round 2 — centralized partial-receive. Used by BOTH the Review EPO
 * modal and the dedicated Receive EPO page so they stay in sync.
 * POST .../receive/line/{n}/qty-receive  body: { QtyReceived, Comment }
 *   → ReceiveQtyResponse { LineNum, QtyOrdered, QtyReceivedTotal,
 *                          QtyRemaining, Status, AllReceived }
 * The backend enforces: after-approval guard, over-receive hard block, and a
 * required comment on partial receives. On a rule violation it returns 400 with
 * { message }, which callers surface to the user.
 */
export async function receiveQty(epoNum, lineNum, qtyReceived, comment) {
    const res = await api.post(
        `/epo/${epoNum}/receive/line/${lineNum}/qty-receive`,
        { QtyReceived: qtyReceived, Comment: comment ?? "" }
    );
    return res.data;
}

/** GET .../receive/log → EpoRecvLogEntry[] */
export async function getReceiveLog(epoNum) {
    const res = await api.get(`/epo/${epoNum}/receive/log`);
    return res.data;
}
